module.exports = __webpack_public_path__ + "static/media/logo-award-fave.8c34966e.png";